import { MNElementContent } from '../elements/elementModelTypes';
import { TiptapContent, TiptapNodeType } from '../tiptap/tiptapTypes';
import { TaskListContentVersion } from './taskListContentVersionUtils';

/**
 * Creates the minimal editable Tiptap document for a blank single-editor task list.
 */
export const createInitialSingleEditorTaskListDocument = (): TiptapContent => ({
    type: TiptapNodeType.doc,
    content: [
        {
            type: TiptapNodeType.taskList,
            content: [
                {
                    type: TiptapNodeType.taskItem,
                    attrs: { checked: false },
                    content: [
                        {
                            type: TiptapNodeType.paragraph,
                        },
                    ],
                },
            ],
        },
    ],
});

/**
 * Creates the persisted content payload for a new single-editor task list element.
 */
export const createInitialSingleEditorTaskListContent = (): MNElementContent => ({
    version: TaskListContentVersion.SingleEditor,
    textContent: createInitialSingleEditorTaskListDocument(),
});
